import React from 'react';

import { DetailPageLayout } from 'src/components/common';
import { PeoPayrollProviderSettingsForm } from 'src/components/peoPayrollProvider';
import { TableDataProvider } from 'src/providers/TableDataProvider';

export const PeoPayrollProviderDetailSettingsPage: React.FC = () => {
  return (
    <DetailPageLayout titleContent="Settings">
      <TableDataProvider>
        <PeoPayrollProviderSettingsForm />
      </TableDataProvider>
    </DetailPageLayout>
  );
};
